import api from "./api";
import { type PriceTier } from "../../types/database";

const DEFAULT_EXCHANGE_RATE = 40;

interface RawPrice {
  usdPrice?: number;
  id: string;
}
interface RawRate {
  UAH?: number;
  id: string;
}

/**
 * Price tiers from `priceValues` (doc id = tier name, field `usdPrice`), with
 * UAH derived from `exchangeRates/USD.UAH`. Sorted ascending.
 */
export async function getPriceValues(): Promise<PriceTier[]> {
  const [prices, rates] = await Promise.all([
    api.get<unknown, RawPrice[]>("/getPriceValues"),
    api.get<unknown, RawRate[]>("/getExchangeRates"),
  ]);

  const usd = Array.isArray(rates) ? rates.find((r) => r.id === "USD") : null;
  const rate = usd && Number(usd.UAH) > 0 ? Number(usd.UAH) : DEFAULT_EXCHANGE_RATE;

  return (Array.isArray(prices) ? prices : [])
    .map((p) => {
      const priceUSD = Number(p.usdPrice ?? 0);
      return {
        tierName: p.id,
        priceUSD,
        priceUAH: Number((priceUSD * rate).toFixed(2)),
      };
    })
    .sort((a, b) => a.priceUSD - b.priceUSD);
}
